"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _kx = require("@/api/kx");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'KxMedal',
  data: function data() {
    return {
      configLoading: false,
      configList: [],
      editDialogVisible: false,
      editForm: {},
      keyword: '',
      userLoading: false,
      userMedals: [],
      total: 0,
      page: {
        page: 1,
        limit: 20
      },
      grantDialogVisible: false,
      grantForm: {
        uid: null,
        medalType: ''
      }
    };
  },
  mounted: function mounted() {
    this.loadConfig();
    // 页面加载时自动查询列表
    this.handleSearchMedal();
  },
  methods: {
    loadConfig: function loadConfig() {
      var _this = this;
      this.configLoading = true;
      (0, _kx.kxMedalConfigApi)().then(function (res) {
        _this.configList = res || [];
        _this.configLoading = false;
      }).catch(function () {
        _this.configLoading = false;
      });
    },
    handleEditConfig: function handleEditConfig(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editDialogVisible = true;
    },
    handleSaveConfig: function handleSaveConfig() {
      var _this2 = this;
      (0, _kx.kxMedalConfigUpdateApi)(this.editForm).then(function () {
        _this2.$message.success('保存成功');
        _this2.editDialogVisible = false;
        _this2.loadConfig();
      });
    },
    handleSearchMedal: function handleSearchMedal() {
      var _this3 = this;
      this.userLoading = true;
      var params = _objectSpread({}, this.page);
      if (this.keyword && this.keyword.trim()) {
        params.keyword = this.keyword.trim();
      }
      (0, _kx.kxMedalUserListApi)(params).then(function (res) {
        _this3.userMedals = res.list || [];
        _this3.total = res.total || 0;
        _this3.userLoading = false;
      }).catch(function () {
        _this3.userMedals = [];
        _this3.total = 0;
        _this3.userLoading = false;
      });
    },
    resetSearch: function resetSearch() {
      this.keyword = '';
      this.page.page = 1;
      this.handleSearchMedal();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.page.limit = val;
      this.page.page = 1;
      this.handleSearchMedal();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page.page = val;
      this.handleSearchMedal();
    },
    handleGrant: function handleGrant() {
      var _this4 = this;
      if (!this.grantForm.uid || !this.grantForm.medalType) {
        this.$message.warning('请填写完整');
        return;
      }
      (0, _kx.kxMedalGrantApi)(this.grantForm).then(function () {
        _this4.$message.success('授予成功');
        _this4.grantDialogVisible = false;
        _this4.handleSearchMedal();
      });
    },
    handleRevoke: function handleRevoke(row) {
      var _this5 = this;
      (0, _kx.kxMedalRevokeApi)({
        uid: row.uid,
        medalType: row.medalType
      }).then(function () {
        _this5.$message.success('撤销成功');
        _this5.handleSearchMedal();
      });
    }
  }
};